var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rs-task-list"},[_c('div',{staticClass:"litigation-wrapper"},[_c('div',{staticClass:"title"},[_vm._v("应诉方案")]),_c('fee-table',{attrs:{"initialPlan":_vm.data.scheme,"order":{
				includeFormType: _vm.data && _vm.data.includeFormType,
				death: _vm.data && _vm.data.death,
			}},on:{"handleCancel":_vm.handleCancel,"handleSubmit":_vm.handleSubmit}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }